module.exports = __webpack_public_path__ + "img/01-1.e0dc042c.png";